import {FC} from "react";
import styled from "styled-components";
import {LabelsInfoFragment} from "./__generated__/LabelesInform.fragment.generated";


const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;


interface LabelsInfoProps {
  info: LabelsInfoFragment
}

const LabelsInform:FC<LabelsInfoProps> = ({ info }) => {
  return (
      <Container>
        <p>Информация о лейбле:</p>
        <h2>{info.name}</h2>
        <p>icon: {info.icon}</p>
      </Container>
  )
}

export default LabelsInform;
